import React from "react";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import FiltroPrecioComponent from "./Componentes/FiltroPrecio/FiltroPrecio.component";
import FiltroClasificacionComponent from "./Componentes/FiltroClasificacion/FiltroClasificacion.component";
import ProductosComponent from "./Componentes/Productos/Productos.component";
import LoaderPortal from "./../../Portales/Loader/Loader.portal";
import ModalMensajeComponent from "./../../Shared/Componentes/ModalMensaje/ModalMensaje.component";
import * as CatalogoActions from "../../Core/Actions/Catalogo.action";
import * as ClasificacionActions from "../../Core/Actions/Clasificacion.action";
import * as CotizacionActions from "./../../Core/Actions/Cotizacion.action";
import "./Catalogo.page.scss";

class CatalogoPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      productos: [],
      productosFiltrados: [],
      PrecioMaximoActual: 0,
      PrecioMinimoActual: 0,
      MaximoSeleccionado: 0,
      MinimoSeleccionado: 0,
      Busqueda: "",
      Modal: {
        Mostrar: false,
        Mensaje: "",
      },
    };
  }

  componentDidMount() {
    this.setState({
      productos: [],
      productosFiltrados: [],
      PrecioMaximoActual: 0,
      PrecioMinimoActual: 0,
      MaximoSeleccionado: 0,
      MinimoSeleccionado: 0,
      Busqueda: "",
      Modal: {
        Mostrar: false,
        Mensaje: "",
      },
    });

    this.BuscarCatalogo();
    this.BuscarClasificacion();
  }

  componentDidUpdate(prevProps) {
    const { cabecera } = this.props.match.params;
    const { cabecera: cabeceraPrev } = prevProps.match.params;

    if (cabecera !== cabeceraPrev) {
      this.setState({
        productos: [],
        productosFiltrados: [],
        PrecioMaximoActual: 0,
        PrecioMinimoActual: 0,
        MaximoSeleccionado: 0,
        MinimoSeleccionado: 0,
        Busqueda: "",
      });

      this.BuscarCatalogo();
      this.BuscarClasificacion();
    }
  }

  BuscarCatalogo = async () => {
    const { obtenerCatalogo } = this.props;
    const { cabecera } = this.props.match.params;

    await obtenerCatalogo(cabecera);

    const { Catalogo } = this.props.catalogoReducer;

    if (Catalogo[0]) {
      const { Productos } = Catalogo[0].datos;
      this.setState({
        productos: Productos,
        productosFiltrados: [],
      });
      this.ObtenerMinimoYMaximo();
    }
  };

  BuscarClasificacion = async () => {
    const { obtenerClasificacionPorCabecera } = this.props;
    const { cabecera } = this.props.match.params;

    await obtenerClasificacionPorCabecera(cabecera);
  };

  ObtenerMinimoYMaximo = () => {
    const { productos } = this.state;
    let { PrecioMaximoActual, PrecioMinimoActual } = this.state;
    let tPrecioMaximo = 0;

    productos.forEach((producto) => {
      tPrecioMaximo = Math.max(tPrecioMaximo, producto.Precio);
    });

    PrecioMaximoActual = tPrecioMaximo;
    PrecioMinimoActual = PrecioMaximoActual;

    productos.forEach((producto) => {
      PrecioMinimoActual = Math.min(PrecioMinimoActual, producto.Precio);
    });

    this.setState({
      PrecioMaximoActual: PrecioMaximoActual,
      PrecioMinimoActual: PrecioMinimoActual,
      MaximoSeleccionado: PrecioMaximoActual,
      MinimoSeleccionado: PrecioMinimoActual,
    });

    this.FiltrarArticulos();
  };

  CambiarPrecio = (Minimo, Maximo) => {
    this.setState({
      MaximoSeleccionado: Maximo,
      MinimoSeleccionado: Minimo,
    });

    this.FiltrarArticulos();
  };

  FiltrarArticulos = () => {
    const {
      productos,
      MaximoSeleccionado,
      MinimoSeleccionado,
      Busqueda,
    } = this.state;

    let productosFiltrados =
      productos.filter((producto) => {
        const { Precio, Descripcion } = producto;

        return (
          Precio >= MinimoSeleccionado &&
          Precio <= MaximoSeleccionado &&
          Descripcion.toLowerCase().includes(Busqueda.toLowerCase())
        );
      }) || [];

    this.setState({
      productosFiltrados: productosFiltrados,
    });
  };

  handleChangeBuscar = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });

    this.FiltrarArticulos();
  };

  handleClickCarrito = async (productos) => {
    const { PedidoActual } = this.props.loginReducer.Cliente.datos;
    const { crearCotizacion, actualizarCotizacion } = this.props;

    if (!PedidoActual || !PedidoActual?.id) {
      await crearCotizacion(productos);
    } else {
      await actualizarCotizacion(productos);
    }

    if (this.props.cotizacionReducer.Resultado !== "S") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: this.props.cotizacionReducer.Mensaje,
        },
      });
      return;
    }
  };

  handleMostrarModal = () => {
    this.setState({
      Modal: {
        Mostrar: !this.state.Modal.Mostrar,
        Mensaje: "",
      },
    });
  };

  render() {
    return (
      <>
        <LoaderPortal />
        <ModalMensajeComponent
          mostrar={this.state.Modal.Mostrar}
          handleCerrar={this.handleMostrarModal}
        >
          <h5>{this.state.Modal.Mensaje}</h5>
        </ModalMensajeComponent>
        <div className="Catalogo__Banner">
          <div className="Catalogo__Banner--Contenedor">
            <div
              style={{
                backgroundImage: `url(${this.props.clasificacionReducer.Clasificacion?.datos?.Url_Banner})`,
              }}
            ></div>
          </div>
        </div>
        <div className="Catalogo__Clasificacion">
          <div className="Catalogo__Clasificacion--Contenedor">
            <h3>
              {this.props.clasificacionReducer.Clasificacion?.datos?.Titulo}
            </h3>
          </div>
        </div>
        <div className="Catalogo__Busqueda">
          <div className="Catalogo__Busqueda--Contenedor">
            <Form.Control
              type="text"
              name="Busqueda"
              placeholder="Buscar..."
              value={this.state.Busqueda}
              onChange={this.handleChangeBuscar}
            />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12 col-lg-4 d-none d-lg-block">
            <FiltroPrecioComponent
              cambiarPrecio={this.CambiarPrecio}
              Minimo={this.state.PrecioMinimoActual}
              Maximo={this.state.PrecioMaximoActual}
            />
            <FiltroClasificacionComponent
              clasificaciones={this.props.clasificacionReducer.Clasificaciones}
            />
          </div>
          <div className="col-12 col-lg-8">
            <ProductosComponent
              productos={this.state.productosFiltrados}
              hayCliente={this.props.loginReducer.hayCliente}
              clickCarrito={this.handleClickCarrito}
              productosPedido={
                this.props.loginReducer.Cliente?.datos?.PedidoActual?.datos
                  ?.Productos || []
              }
            />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({
  catalogoReducer,
  clasificacionReducer,
  loginReducer,
  cotizacionReducer,
}) => {
  return {
    catalogoReducer,
    clasificacionReducer,
    loginReducer,
    cotizacionReducer,
  };
};

const mapDispatchToProps = {
  ...CatalogoActions,
  ...ClasificacionActions,
  ...CotizacionActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(CatalogoPage);
